import React, { useEffect, useState, useRef } from 'react'
import './ActivateAccount.css'

import Steps from '../../../components/Steps/'

import GetStart from './GetStart'
import SecurityQuestion from './SecurityQuestion'
import SetPassword from './SetPassword'
import Success from './Success'
import { useDispatch, useSelector } from 'react-redux'
import { getChallengeQuestions, updateAccountActivateData } from '../../../actions'
import { Toast } from 'primereact/toast';

const ActivateAccount = () => {


  const toast = useRef(null)
  const dispatch = useDispatch()
  const challengeQuestions = useSelector(state => state.challengeQuestionsReducers)
  const accountActivateData = useSelector(state => state.accountActivateReducers)
  const interactiveItems = [
    { label: 'Started' },
    { label: 'Security Questions' },
    { label: 'Set Password' }
  ];
  const [requiredRecaptcha, setRequiredRecaptcha] = useState(false)

  const [activeIndex, setActiveIndex] = useState(null)
  const [validateRecapt, setValidateRecapt] = useState(null)


  const isFirstRender = useRef(true)
  const [requestGetChallengeQuestions, setRequestGetChallengeQuestion] = useState(false)
  const [defaultLoginURL] = useState('/accountmanagement/auth/my-profile')
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }
    if (requestGetChallengeQuestions && challengeQuestions.requesting_get_successful) {

      dispatch(updateAccountActivateData(Object.assign({}, accountActivateData.data, {
        question1: challengeQuestions.data.questions[0].value,
        question2: challengeQuestions.data.questions[1].value,
        question3: challengeQuestions.data.questions[2].value
      })))
      setRequestGetChallengeQuestion(false)
    }
    if (requestGetChallengeQuestions && challengeQuestions.message !== null) {
      toast.current.show({ severity: 'error', summary: "Challenge Questions API", detail: "There was an unexpected error, please refresh the page and try again. If the problem persists, please contact help desk for support.", sticky: true });
      setRequestGetChallengeQuestion(false)
    }

  })

  const fetchQuestions = () => {
    dispatch(getChallengeQuestions({}))
    setRequestGetChallengeQuestion(true)
  }

  useEffect(() => {
    fetchQuestions()
  }, [])// eslint-disable-line react-hooks/exhaustive-deps

  return <div>
    <Toast ref={toast} />
    <div className="steps-title">{activeIndex !== null && activeIndex !== 3 ? `${interactiveItems[activeIndex].label}` : null}</div>
    <div className="steps-container-margin">
      {activeIndex !== null && activeIndex !== 3 ? <Steps items={interactiveItems} currentIndex={activeIndex} /> : null}
    </div>
    {activeIndex === null ? <GetStart defaultLoginURL={defaultLoginURL} requiredRecaptcha={requiredRecaptcha} setRequiredRecaptcha={setRequiredRecaptcha} validateRecapt={validateRecapt} setValidateRecapt={setValidateRecapt} setActiveIndex={setActiveIndex} toast={toast} /> : null}

    {activeIndex === 1 ? <SecurityQuestion setActiveIndex={setActiveIndex} setValidateRecapt={setValidateRecapt} /> : null}

    {activeIndex === 2 ? <SetPassword setActiveIndex={setActiveIndex} setValidateRecapt={setValidateRecapt} toast={toast} /> : null}

    {activeIndex === 3 ? <Success defaultLoginURL={defaultLoginURL}/> : null}

  </div>

}

export default ActivateAccount